import { useEffect, useState } from "react";
import { useStores } from "./useStores";
import { enrichSearchResultsWithDistance } from "../utils/storeDistance";

export function useEnrichedSearchResults<T extends { storeId?: string }>(
  results: T[] | undefined,
  zipCode: string,
  retailer: string
): T[] {
  const { stores } = useStores(retailer as any);
  const [enriched, setEnriched] = useState<T[]>(results || []);

  useEffect(() => {
    let cancelled = false;
    const base = results || [];

    if (!base.length || !zipCode.trim()) {
      setEnriched(base);
      return;
    }

    enrichSearchResultsWithDistance(base, zipCode.trim(), stores, retailer).then((next) => {
      if (!cancelled) setEnriched(next);
    });

    return () => {
      cancelled = true;
    };
  }, [results, zipCode, stores, retailer]);

  return enriched;
}
